<template>
  <div>
    <a id="wrapper">
      <img class="nos" v-bind:src="nos" @mouseover="nos = hahogy">
    </a>
    <div id="header">
      <h4>Puzsér mocskosul tudja a tutit. Itt a lehetőség, hogy ezúttal ne adja, hanem kapja az ívet. <br>Oszd ki és oszd
        meg másokkal is!</h4>
    </div>
  </div>
</template>

<script>
    export default {
        name: "LogoItem",
        data() {
            return {
                nos: require('@/assets/mayorpuzser1.svg'),
                hahogy: require('@/assets/mayorpuzser3.svg'),
            }
        }
    }
</script>

<style scoped>

  #wrapper {
    width: auto;
    overflow: hidden;
    alignment: center;
  }

  .nos {
    alignment: center;
  }

</style>
